module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/alarms2@2x-9209b7d8e2d487107955a8ff5128cb92.png";